import type { ReactNode } from "react";

export function Notice({ title, body, children }: { title: string; body: string; children?: ReactNode }) {
  return (
    <div className="border-hairline rounded-xl border border-dashed px-6 py-10 text-center">
      <p className="type-headline">{title}</p>
      <p className="text-muted-foreground type-body mx-auto mt-1 max-w-sm">{body}</p>
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
